module.exports = __webpack_public_path__ + "img/fi.1c905aa5.svg";